import * as actionType from "../constants/action_types";
const initialState = {
  list: null,
  details: null,
  users: null,
  users_stat: null,
  subscriptions: null,
  subscription_items: null,
  industry: null,
  usage: null,
  modules: null,
  activites: null,
  allModules: null,
  update_response: "",
  login_as_user: "",
  policy: "",
  notes: {
    data: [],
    current_page: 1,
    total_pages: null,
  },
  policyFields: [],
  workflow_builder: {
    node_filters: []
  }
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET responses start
    case actionType.GETALLMODULES_RESPONSE:
      return { ...state, allModules: action.payload.data };
    case actionType.GETCOMPANIES_RESPONSE:
      return { ...state, list: action.payload };
    case actionType.GETCOMPANY_RESPONSE:
      return { ...state, details: action.payload };
    case actionType.GETCOMPANYUSER_RESPONSE:
      return { ...state, users: action.payload };
    case actionType.GETCOMPANYUSERSTAT_RESPONSE:
      return { ...state, users_stat: action.payload };
    case actionType.GETSUBSCRIPTIONS_RESPONSE:
      return { ...state, subscriptions: action.payload };
    case actionType.GETSUBSCRIPTION_ITEMS_RESPONSE:
      return { ...state, subscription_items: action.payload };
    case actionType.GETINDUSTRY_RESPONSE:
      return { ...state, industry: action.payload.data };
    case actionType.GETUSAGE_RESPONSE:
      return { ...state, usage: action.payload };
    case actionType.GETMODULES_RESPONSE:
      return { ...state, modules: action.payload.result };
    case actionType.GETCOMPANYPOLICY_RESPONSE:
      return { ...state, policy: action.payload.data?.data };
    case actionType.GETCOMPANYINVOICE_RESPONSE:
      return {
        ...state,
        invoice: { ...action.payload.data, offsets: action.payload.offsets },
      };
    case actionType.GETCOMPANYSTAT_RESPONSE:
      return { ...state, insights: action.payload.data };
    case actionType.GETNOTES_RESPONSE:
      console.log(action.payload.data);
      return {
        ...state,
        details: {
          ...state.details,
          count: {
            ...state.details.count,
            notes: action.payload.total_records || state.details.count.notes,
          },
        },
        notes: {
          data: action.payload.data
            ? [...state.notes.data, ...action.payload.data]
            : [...state.notes.data],
          current_page: action.payload.current_page || 1,
          total_pages:
            action.payload.data?.length === 0
              ? Math.ceil(state.activites.data?.length / action.payload.limit)
              : action.payload.total_pages || null,
        },
      };
    case actionType.GETINTEGRATIONS_RESPONSE:
      return {
        ...state,
        details: {
          ...state.details,
          count: {
            ...state.details.count,
            integrations:
              action.payload.total_records || state.details.count.integrations,
          },
        },
        integrations: action.payload,
      };
    case actionType.GETCREDENTIALS_RESPONSE:
      return {
        ...state,
        details: {
          ...state.details,
          count: {
            ...state.details.count,
            credentials:
              action.payload.totalCount || state.details.count.credentials,
          },
        },
        credentials: { ...state.credentials, list: action.payload },
      };
    case actionType.GETCREDENTIAL_RESPONSE:
      return {
        ...state,
        credentials: { ...state.credentials, details: action.payload.data },
      };
    case actionType.GET_COMPANY_POLICY_FIELDS_RESPONSE:
      return {
        ...state,
        policyFields: action.payload.data
      };

    case actionType.GET_COMPANY_ZUPER_PAY_DETAILS_RESPONSE:
      return {
        ...state,
        zuper_pay: action.payload.data
      };
    case actionType.GET_WORK_BUILDER_NODE_FILTERS_RESP:
      console.log(action.payload,`action.payload.`)
      return {
        ...state,
        workflow_builder: {
          node_filters: action.payload.data
        }
      };
    // GET responses end

    // POST and PUT responses cases start
    case actionType.LOGINASUSER_RESPONSE:
      return { ...state, login_as_user: action.payload };
    case actionType.CREATECOMPANY_RESPONSE:
    case actionType.EDITCOMPANY_RESPONSE:
    case actionType.UPDATEMODULES_RESPONSE:
    case actionType.TOGGLECOMPANY_RESPONSE:
    case actionType.TOGGLEUSER_RESPONSE:
    case actionType.UPDATEUSERBILLING_RESPONSE:
    case actionType.TOGGLESUBSCRIPTION_RESPONSE:
    case actionType.SAVENOTE_RESPONSE:
    case actionType.EDITNOTE_RESPONSE:
    case actionType.EDITCREDENTIAL_RESPONSE:
    case actionType.ADDCREDENTIAL_RESPONSE:
    case actionType.CREATESUBSCRIPTION_RESPONSE:
    case actionType.EDITSUBSCRIPTION_RESPONSE:
    case actionType.DELETENOTE_RESPONSE:
    case actionType.DELETECREDENTIAL_RESPONSE:
    case actionType.EDIT_ZUPER_PAY_RESPONSE:
    case actionType.ADD_FLEET_AUTH_RESPONSE:
      return { ...state, update_response: action };
    // POST and PUT responses cases end

    default:
      return state;
  }
};

export { companyReducer };
